import * as yup from 'yup';

const questionsEndDate = yup
  .date()
  .required('End date for questions is required field')
  .test('future', 'End date for questions must be in the future', (value) => !value || value > new Date())
  .test('before-last-day', 'End date for questions must be on or before last day to respond', function (value) {
    const { lastDayToRespond } = this.parent;
    return !value || !lastDayToRespond || value <= new Date(lastDayToRespond);
  });

export const mainInfoSchema =(step) => (
  {
    0: yup.object().shape({
      // agreementOrDps: yup.string().required('Agreement is required field'),
      buyer: yup.string().required('Buyer is required field'),
    }),
    1: yup.object().shape({
      // agreementOrDps: yup.string().required('Agreement is required field'),
      buyer: yup.string().required('Buyer is required field'),
      headline: yup.string().required('Headline is required field'),
      role: yup.string().required('Role is required field'),
      experienceLevel: yup.string().required('Experience level is required field'),
      description: yup.string().required('Assignment description is required field'),
      type: yup.string().required('Type is required field'),
      hoursPerWeek: yup.number().required('Hours per week is required field').min(1, 'Hours per week must be at least 1'),
      maxRate: yup.string().required('Max rate is required field'),
      referenceNumber: yup.string().required('Reference number is required field'),
      locations: yup.array().when('usesNuts', {
        is: true,
        then: (schema) => schema.required('NUTS codes is required field').min(1, 'NUTS codes is required field'),
        otherwise: (schema) => schema.notRequired(),
      }),
      places: yup.array().required('Locations is required field').min(1, 'Locations is required field').max(10, 'At most 10 locations'),
      competenceAreas: yup.array().required("Competence Areas is required field").min(1, "Competence Areas is required field"),
      startDate: yup.date().required('Start date is required field'),
      endDate: yup.date().required('End date is required field'),
      applicationType: yup.string().oneOf(['email', 'url', 'in_app']).required('Application type is required field'),
      lastDayToRespond: yup.date().required('Last day to respond is required field').min(new Date(), 'Last day to respond must be in the future'),
      questionsEndDate,
      applicationEmail: yup.string().when('applicationType', {
        is: 'email',
        then: (schema) => schema.email('Invalid email').required('Application email is required field'),
        otherwise: (schema) => schema.notRequired(),
      }),
      applicationURL: yup.string().when('applicationType', {
        is: 'url',
        then: (schema) => schema.url('Application URL must be a valid URL (e.g., https://example.com)').required('Application URL is required field'),
        otherwise: (schema) => schema.notRequired(),
      }),
      hideBuyer: yup.boolean(),
    }),
  }
)[step];

export const additionalDetailsSchema = yup.object().shape({
  headline: yup.string().required('Headline is required field'),
  role: yup.string().required('Role is required field'),
  experienceLevel: yup.string().required('Experience level is required field'),
  description: yup.string().required('Assignment description is required field'),
  type: yup.string().required('Type is required field'),
  hoursPerWeek: yup.number().required('Hours per week is required field').min(1, 'Hours per week must be at least 1'),
  maxRate: yup.string().required('Max rate is required field'),
  referenceNumber: yup.string().required('Reference number is required field'),
  locations: yup.array().when('usesNuts', {
    is: true,
    then: (schema) => schema.required('NUTS codes is required field').min(1, 'NUTS codes is required field'),
    otherwise: (schema) => schema.notRequired(),
  }),
  places: yup.array().required('Locations is required field').min(1, 'Locations is required field').max(10, 'At most 10 locations'),
  competenceAreas: yup.array().required("Competence Areas is required field").min(1, "Competence Areas is required field"),
  startDate: yup.date().required('Start date is required field'),
  endDate: yup.date().required('End date is required field'),
  applicationType: yup.string().oneOf(['email', 'url', 'in_app']).required('Application type is required field'),
  lastDayToRespond: yup.date().required('Last day to respond is required field').min(new Date(), 'Last day to respond must be in the future'),
  questionsEndDate,
  applicationEmail: yup.string().when('applicationType', {
    is: 'email',
    then: (schema) => schema.required('Application email is required field').email('Invalid email'),
    otherwise: (schema) => schema.notRequired(),
  }),
  applicationURL: yup.string().when('applicationType', {
    is: 'url',
    then: (schema) => schema.required('Application URL is required field').url('Application URL must be a valid URL (e.g., https://example.com)'),
    otherwise: (schema) => schema.notRequired(),
  }),
  hideBuyer: yup.boolean(),
});
